const SORT_OPTIONS = [
  { value: 'bubble', label: 'Bubble Sort' },
  { value: 'heap', label: 'Heap Sort' },
  { value: 'insertion', label: 'Insertion Sort' },
  { value: 'merge', label: 'Merge Sort' },
  { value: 'quick', label: 'Quick Sort' },
  { value: 'selection', label: 'Selection Sort' },
  { value: 'shell', label: 'Shell Sort' }
]

export default SORT_OPTIONS
